<template lang="pug">
.title-section
  h3(:class="titleStyle") {{ sectionText }}
  br(v-if='sectionText2')
  h3(v-if="sectionText2" :class="titleStyle") {{ sectionText2 }}
  span.title-subtitleSection(v-if="displaySubtitleSection" :class="isSubtitleSectionOnPopup ? 'title-subtitleSection--popup' : ''") {{ subtitleText }}

  span.title-counter.show--bigScreens(v-if="displayCardCounter") {{cardIndex.toString() + '/' + cardAmount.toString()}}
  AbsoluteTopRightBtnText(v-if="displaySeeMoreText")
  div
    DisplayFilter(
      :displayFilter="displayFilter"
      :displayLayoutOption="displayLayoutOption"
      :type='type'
      :filterType='filterType'
      :listMode='listMode'
      @filter="filter"
      @changeViewMode="changeViewMode"
      @changeType='changeType')
    DisplayFilterMobile(
      :displayFilter="displayFilter"
      :displaySort="displaySort"
      :displayLayoutOption="displayLayoutOption"
      :filterType='filterType'
      :type='type'
      :listMode='listMode'
      @filter="filter"
      @changeViewMode="changeViewMode"
      @sortByType="sortByType"
      @changeType='changeType')
  .title-addArticle(v-if="displayAddButton" @click="$emit('togglePopupAddComment')")
    .icon-add.show--bigScreens
    span.title-textAddArticle 新增查核
</template>
<script>
import AbsoluteTopRightBtnText from '@/components/modules/button_text/absolute-top-right-btn-text.vue';
import DisplayFilter from '@/components/modules/section_title/display_filter.vue';
import DisplayFilterMobile from '@/components/modules/section_title/display_filter_mobile.vue';
import DisplayLayoutOption from '@/components/modules/section_title/display_layout_option.vue';

export default {
  props: {
    filterType: String,
    sectionText: String,
    sectionText2: String,
    styleSmall: Boolean,
    subtitleText: String,
    displayCardCounter: Boolean,
    cardIndex: Number,
    cardAmount: Number,
    displaySeeMoreText: Boolean,
    displayFilter: Boolean,
    displayLayoutOption: Boolean,
    displaySubtitleSection: Boolean,
    displayAddButton: Boolean,
    displaySort: Boolean,
    isSubtitleSectionOnPopup: Boolean,
    listMode: Boolean,
    notBold: Boolean
  },
  data() {
    return {
      currentSort: null
    };
  },
  computed: {
    type() {
      const _type = this.$route.query.type;
      return _type || this.filterType;
    },
    titleStyle() {
      const baseClass = this.styleSmall ? "title-textSection2" : "title-textSection";
      return this.notBold ? baseClass + 'NoBold' : baseClass;
    }
  },
  components: {
    AbsoluteTopRightBtnText,
    DisplayFilter,
    DisplayFilterMobile,
    DisplayLayoutOption
  },
  methods: {
    filter(start, end) {
      if (start === 'all') {
        this.$emit('filter', start);
      } else {
        this.$emit('filter', start, end);
      }
    },
    sortByType(data) {
      this.$emit('sortByType', data);
    },
    changeViewMode(listMode) {
      this.$emit('changeViewMode', listMode);
    },
    changeType(filtertype) {
      this.$emit('changeType', filtertype);
    }
  }
};
</script>
